import { FIELD_MAP } from 'modules/finance/components/FinancialWorkspace/components/Table/const'
import { useInsightTableItems } from 'modules/finance/components/FinancialWorkspace/hooks/useInsightTableItems'
import { InsightTableType } from 'modules/finance/components/FinancialWorkspace/types/table'
import { TableDataVariables } from 'modules/finance/components/FinancialWorkspace/types/table'

const formatVariables = (variables: TableDataVariables) => {
  const field = FIELD_MAP[variables.groupBy]

  const sortOrder = {
    field,
    order: 'asc',
  }

  const pagination = {
    after: variables.after,
    itemsPerPage: variables.itemsPerPage,
  }

  // remove pagination options and unused common variables
  // eslint-disable-next-line unused-imports/no-unused-vars
  const {
    after,
    offset,
    period,
    itemsPerPage,
    includeFuturePeriods,
    formattedCompareToEndDate,
    formattedCompareToStartDate,
    ...rest
  } = variables

  return {
    resourceFilter: {
      ...rest,
      groupBy: variables.groupBy,
      insightTableType: InsightTableType.Payroll,
    },
    sortOrder: field ? sortOrder : undefined,
    pagination,
  }
}

export const usePayrollGroupData = (variables: TableDataVariables) => {
  const { resourceFilter, sortOrder, pagination } = formatVariables(variables)

  const result = useInsightTableItems({
    resourceFilter,
    sortOrder,
    ...pagination,
  })

  return result
}
